export enum ExcelExportTabType {
  All = 'all',
  Fields = 'fields',
  Clauses = 'provisions',
  Tables = 'tables',
}
